module.exports = [{"type":"title","text":"2025-09-10"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Changes to api rate limits, please refer to:<a href='https://bingx-api.github.io/docs/#/en-us/swapV2/base-info.html#Rate%20limit' target='_blank'>Rate limit</a>"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-09-10.json
// module id = aYNr
// module chunks = 3